import { useCallback, useEffect, useMemo, useState } from "react";

function usePageFocus(onFocus: () => void) {
  // Memoize the callback to prevent unnecessary effect re-runs
  const memoizedOnFocus = useCallback(() => {
    onFocus();
  }, [onFocus]);

  useEffect(() => {
    // Handle visibility change for better cross-browser support
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        memoizedOnFocus();
      }
    };

    // Handle window focus event
    const handleFocus = () => {
      memoizedOnFocus();
    };

    // Add event listeners
    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Clean up event listeners
    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [memoizedOnFocus]);
}

export default usePageFocus;
